import React from 'react'
import axios from "axios/index"
import {Button, Label, Input, FormText} from 'reactstrap'
import moment from 'moment'

export default class Feed extends React.Component {
    constructor(props) {
        super(props)
        this.state = {feeds: [], message: ''}
        this.url = this.props.dashboard ? '/dashboard/feeds/' : this.props.admin ? '/admin/feeds/' : '/account/feeds/'
        moment.locale(this.props.locale || 'en')
    }

    componentDidMount() {
        axios.get(this.url + this.props.res_id + '.json?locale=' + this.props.locale)
            .then((res) => {
                this.setState({feeds: res.data})
                this.scrollToBottom()
            })
    }

    scrollToBottom = () => {
        if (this.state.message !== '') return false
        this.messagesEnd.parentNode.scrollTop = this.messagesEnd.offsetTop
    }

    componentDidUpdate() {
        this.scrollToBottom()
    }

    sendFeed = () => {
        if (this.state.sendingFeed || this.state.message.length === 0) return
        this.setState({sendingFeed: true})
        axios.post(this.url,
            {
                message: this.state.message,
                reservation_id: this.props.res_id,
                authenticity_token: CSRF_TOKEN
            })
            .then((res) => {
                this.setState({feeds: [...this.state.feeds, res.data.feed], message: '', sendingFeed: false})
            })
    }

    _handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.sendFeed()
        }
    }

    render() {
        const feeds = this.state.feeds.map(f => {
            const indent = this.props.dashboard && f.feed_owner === 'provider'|| !this.props.dashboard && f.feed_owner === 'user'
            return (
                <div key={f.id} className={indent ? "p-2 mb-3" : 'p-2 pl-5 mb-3'} style={{borderBottom: '1px solid #eeeeee'}}>
                    <b className={indent ? 'text-secondary small' : 'small'}>{f.user}</b>
                    <small className="text-muted">
                        {' '}{moment(f.created).format("DD-MMM HH:mm")}
                        {(this.props.dashboard && f.feed_owner === 'provider' || !this.props.dashboard && f.feed_owner === 'user' && f.feed_type !== 'voucher' || this.props.admin && f.feed_owner !== 'eurocars') &&
                        <span>
                         {f.read ? <i className={'ml-2 text-primary fa fa-envelope-open'} title={"Viewed"}/> :
                        <i className={'ml-2 text-warning fa fa-envelope'} title={"Not viewed"}/>}
                        </span>
                        }
                    </small>
                    <br/>
                    {f.message.map((m, idx) => {
                        return (
                            <div key={'sm_' + idx}>{m}</div>
                        )
                    })}
                </div>
            )
        })
        return (
            <div>
                <div className="mb-2" style={{maxHeight: '300px', overflow: 'auto'}}>
                    {feeds}
                    <div ref={el => this.messagesEnd = el}/>
                </div>
                {this.props.status !== 'canceled' && !this.props.admin &&
                <div className="row">
                    <div className="col pr-0">
                        <Input type="text" name="Message" value={this.state.message}
                               onChange={e => this.setState({message: e.target.value})}
                               onKeyPress={this._handleKeyPress}
                               placeholder={this.props.t.note}
                        />
                    </div>
                    <div className="col-auto">
                        <Button color="success"
                                className="btn"
                                onClick={this.sendFeed}
                                disabled={this.state.sendingFeed}
                        >{this.state.sendingFeed ? 'Sending...' : this.props.t.button}</Button>

                    </div>
                </div>
                }
            </div>
        )
    }
}